import '../../assets/components/SectionBlock/sectionBlock.css';const e = "_sectionHeader_149wm_9", c = {
  "kcc-section-block": "_kcc-section-block_149wm_1",
  sectionHeader: e
};
export {
  c as default,
  e as sectionHeader
};
